export const GET_CATEGORY_LISTING = 'GET_CATEGORY_LISTING'
export const SET_CATEGORY_LISTING = 'SET_CATEGORY_LISTING'

export const GET_ACTIVE_CATEGORY = 'GET_ACTIVE_CATEGORY'
export const SET_ACTIVE_CATEGORY = 'SET_ACTIVE_CATEGORY'

export const GET_ADD_APP_PERMISSION = "GET_ADD_APP_PERMISSION";
export const SET_ADD_APP_PERMISSION = "SET_ADD_APP_PERMISSION";

export const GET_CHECK_APP_PERMISSION = "GET_CHECK_APP_PERMISSION";
export const SET_CHECK_APP_PERMISSION = "SET_CHECK_APP_PERMISSION";
export const SET_IS_CHECK_APP_PER = "SET_IS_CHECK_APP_PER";

export const GET_APPLICATION_LISTING = "GET_APPLICATION_LISTING";
export const SET_APPLICATION_LISTING = "SET_APPLICATION_LISTING";

export const GET_APP_AREA_LISTING = "GET_APP_AREA_LISTING";
export const SET_APP_AREA_LISTING = "SET_APP_AREA_LISTING";

export const GET_CHECK_CATEGORY = "GET_CHECK_CATEGORY";
export const SET_CHECK_CATEGORY = "SET_CHECK_CATEGORY";
export const SET_IS_CATEGORY_CHECK = "SET_IS_CATEGORY_CHECK";

export const SET_IS_CHECK = "SET_IS_CHECK"

export const GET_ADD_CATEGORY = "GET_ADD_CATEGORY";
export const SET_ADD_CATEGORY = "SET_ADD_CATEGORY";

export const GET_APP_PERMISSION_LISTING = 'GET_APP_PERMISSION_LISTING'
export const SET_APP_PERMISSION_LISTING = 'SET_APP_PERMISSION_LISTING'

export const GET_APP_PERMISSION_BY_ID = 'GET_APP_PERMISSION_BY_ID'
export const SET_APP_PERMISSION_BY_ID = 'SET_APP_PERMISSION_BY_ID'

export const GET_SECURITY_ROLE_BY_ID = 'GET_SECURITY_ROLE_BY_ID'
export const SET_SECURITY_ROLE_BY_ID = 'SET_SECURITY_ROLE_BY_ID'

export const GET_DELETE_APP_PERMISSION = 'GET_DELETE_APP_PERMISSION'
export const SET_DELETE_APP_PERMISSION = 'SET_DELETE_APP_PERMISSION'

export const GET_DELETE_SECURITY_ROLE = 'GET_DELETE_SECURITY_ROLE'
export const SET_DELETE_SECURITY_ROLE = 'SET_DELETE_SECURITY_ROLE'

export const GET_APP_AREA_CHECK = "GET_APP_AREA_CHECK";
export const SET_APP_AREA_CHECK = "SET_APP_AREA_CHECK";
export const SET_IS_APP_AREA_CHECK = "SET_IS_APP_AREA_CHECK";

export const GET_ADD_APP_AREA = "GET_ADD_APP_AREA";
export const SET_ADD_APP_AREA = "SET_ADD_APP_AREA";

export const GET_APP_AREA_BY_ID = 'GET_APP_AREA_BY_ID'
export const SET_APP_AREA_BY_ID = 'SET_APP_AREA_BY_ID'

export const GET_DELETE_APP_AREA = 'GET_DELETE_APP_AREA'
export const SET_DELETE_APP_AREA = 'SET_DELETE_APP_AREA'

export const GET_APPLICATION_CHECK = "GET_APPLICATION_CHECK";
export const SET_APPLICATION_CHECK = "SET_APPLICATION_CHECK";
export const SET_IS_APPLICATION_CHECK = "SET_IS_APPLICATION_CHECK";

export const GET_ADD_APPLICATION = "GET_ADD_APPLICATION";
export const SET_ADD_APPLICATION = "SET_ADD_APPLICATION";

export const GET_DELETE_CATEGORY = 'GET_DELETE_CATEGORY';
export const SET_DELETE_CATEGORY = 'SET_DELETE_CATEGORY';

export const GET_CATEGORY_BY_ID = 'GET_CATEGORY_BY_ID';
export const SET_CATEGORY_BY_ID = 'SET_CATEGORY_BY_ID';

export const GET_APPLICATION_BY_ID = 'GET_APPLICATION_BY_ID';
export const SET_APPLICATION_BY_ID = 'SET_APPLICATION_BY_ID';

export const GET_ACTIVE_APPLICATION = 'GET_ACTIVE_APPLICATION'
export const SET_ACTIVE_APPLICATION = 'SET_ACTIVE_APPLICATION'

export const GET_ACTIVE_APP_AREA = "GET_ACTIVE_APP_AREA";
export const SET_ACTIVE_APP_AREA = "SET_ACTIVE_APP_AREA";

export const GET_DELETE_APPLICATION = "GET_DELETE_APPLICATION";
export const SET_DELETE_APPLICATION = "SET_DELETE_APPLICATION";

export const GET_CREATE_USER = "GET_CREATE_USER";
export const SET_CREATE_USER = "SET_CREATE_USER";

export const GET_USER_GRID_DATA = "GET_USER_GRID_DATA";
export const SET_USER_GRID_DATA = "SET_USER_GRID_DATA";

export const GET_USER = "GET_USER";
export const SET_USER = "SET_USER";

export const UPDATE_CREATE_USER = "UPDATE_CREATE_USER";

export const GET_USER_UPN_DATA= "GET_USER_UPN_DATA";
export const SET_USER_UPN_DATA = "SET_USER_UPN_DATA";

export const GET_SECURITY_PERMISSION_LISTING = 'GET_SECURITY_PERMISSION_LISTING';
export const SET_SECURITY_PERMISSION_LISTING = 'SET_SECURITY_PERMISSION_LISTING';

export const GET_SECURITY_ROLE_LISTING = 'GET_SECURITY_ROLE_LISTING';
export const SET_SECURITY_ROLE_LISTING = 'GET_SECURITY_ROLE_LISTING';

export const GET_ACTIVE_ROLES = 'GET_ACTIVE_ROLES';
export const SET_ACTIVE_ROLES = 'SET_ACTIVE_ROLES';

export const GET_ADD_SECURITY_ROLE = "GET_ADD_SECURITY_ROLE";
export const SET_ADD_SECURITY_ROLE = "SET_ADD_SECURITY_ROLE";


export const GET_USER_DIVISIONS= "GET_USER_DIVISIONS";
export const SET_USER_DIVISIONS= "SET_USER_DIVISIONS";

export const GET_USER_COST_CENTER= "GET_USER_COST_CENTER";
export const SET_USER_COST_CENTER= "SET_USER_COST_CENTER";

export const GET_CHECK_USER = "GET_CHECK_USER";
export const SET_CHECK_USER = "SET_CHECK_USER";
export const SET_IS_USER_CHECK = "SET_IS_USER_CHECK";

export const GET_TIME_ZONE = 'GET_TIME_ZONE';
export const SET_TIME_ZONE = 'SET_TIME_ZONE';

export const UPLOAD_APPLICATION_ICON = "UPLOAD_APPLICATION_ICON";
export const SET_UPLOAD_APPLICATION_ICON = "SET_UPLOAD_APPLICATION_ICON";
